import { WebPlugin } from '@capacitor/core';
export class BarkoderWeb extends WebPlugin {
}
//# sourceMappingURL=web.js.map